<script>
import debounce from 'lodash.debounce';
import DateUtils from './../utils/DateUtils.js';
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'has-pagination',
  data () {
    return {
      currentPage: 1,
      paginationMetaData: null,
      orderColumn: 'id',
      orderDirection: 'DESC'
    };
  },
  mounted () {
    this.loadOrderSettingsFromLocalStorage(this.$options.name);
    this.$bus.$on('pagination-page-changed', this.setPage);
    this.$bus.$on('pagination-reset', this.resetPagination);
    this.$bus.$on('table-ordering-change', this.orderingChange);
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let paramsData = {
        where: {
          search: this.filters.search
        },
        order: {
          column: this.orderColumn,
          direction: this.orderDirection
        }
      };

      if (this.$options.name === 'airports') {
        paramsData.where.disabled = 0;
      }

      if (this.$options.hasDateRangeFilter) {
        if (this.filters.dateRange.startDate) {
          paramsData.where.start_date_from = DateUtils.convertDateToString(this.filters.dateRange.startDate);
        }

        if (this.filters.dateRange.endDate) {
          paramsData.where.start_date_to = DateUtils.convertDateToString(this.filters.dateRange.endDate);
        }
      }

      if (this.$options.additionalFilters) {
        let additionalFilterFields = Object.keys(this.$options.additionalFilters);

        for (let i = 0; i < additionalFilterFields.length; i++) {
          let filterName = additionalFilterFields[i];

          if (this.filters[filterName] !== null) {
            paramsData.where[filterName] = this.filters[filterName];
          }
        }
      }

      let endpointBase = this.$options.name;

      if (this.$options.endpoint) {
        endpointBase = this.$options.endpoint;
      }

      ListUtils.loadPaginatedItemsData(this, {
        endpoint: '/' + endpointBase + '/items?page=' + this.currentPage,
        listField: this.$options.name,
        loadError: 'loadError',
        params: paramsData
      });
    },
    setPage (page) {
      this.currentPage = page;
      this.debouncedLoadFilteredData();
    },
    resetPagination () {
      this.currentPage = 1;
      this.debouncedLoadFilteredData();
    },
    loadOrderSettingsFromLocalStorage (viewName) {
      if (window.localStorage.getItem('crm-ordering-' + viewName + '-column')) {
        this.orderColumn = window.localStorage.getItem('crm-ordering-' + viewName + '-column').replace(/[^a-z0-9_\-]/gmi, '');
      }

      if (window.localStorage.getItem('crm-ordering-' + viewName + '-direction')) {
        this.orderDirection = window.localStorage.getItem('crm-ordering-' + viewName + '-direction') === 'DESC' ? 'DESC' : 'ASC';
      }
    },
    orderingChange (column, direction) {
      this.orderColumn = column;
      this.orderDirection = direction;
      this.debouncedLoadFilteredData();
    }
  },
  beforeDestroy () {
    this.$bus.$off('pagination-page-changed', this.setPage);
    this.$bus.$off('pagination-reset', this.resetPagination);
    this.$bus.$off('table-ordering-change', this.orderingChange);
  }
}
</script>
